import './trusted-security-policies';

import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/i18n/config';
import { installChunkErrorReload } from './routing/lazy/reloadOnChunkError';
import './index.css';
import 'hephaestus/web/assets/index.css';

installChunkErrorReload();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(<App />);
